import React, { useEffect, useCallback } from 'react';
import api from '../../common/lib/api';

import Managed, { useManaged } from '../../common/components/Managed';
import StaticTable from '../../common/components/StaticTable';
import { InputGroup } from '@blueprintjs/core';

const DEFAULT_DATA = [];

const PCS_LICENSE_FIELDS = [
  { id: 'email', name: 'Email', renderer: DetailsLinkRenderer },
  { id: 'status', name: 'License Status' },
  { id: 'uploadDownloadCredits', name: 'Credits', type: 'number' },
  { id: 'userType', name: 'User Type' },
  { id: 'companyName', name: 'Company', renderer: FilterLinkRenderer },
  { id: 'companyId', name: 'Company Id', renderer: FilterLinkRenderer },
  { id: 'firstName', name: 'First Name' },
  { id: 'lastName', name: 'Last Name' },
  { id: 'mobile', name: 'Mobile', type: 'mobile' },
  { id: 'expireAt', name: 'Expiry', type: 'datetime' },
  { id: 'lastUsedAt', name: 'Last Use', type: 'datetime' },
  { id: 'period', name: 'Last Renewed'},
];

function FilterLinkRenderer({ value, field, row }) {
  return <a href={`/manage/pcs-licenses?filter=${value}`}>{value}</a>;
}

function DetailsLinkRenderer({ value, field, row }) {
  return <a href={`/manage/pcs-license/${row.system}-${value}`}>{value}</a>;
}

export default function Page() {
  const params = new URLSearchParams(window.location.search);
  const [state, setLicenses, setError] = useManaged(DEFAULT_DATA);
  let query = (params.get("filter") || '').trim().replace(/\s+/g, ' ');

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/pcs-licenses');
      let list = data.data;
      function match(str, query) {
        return str.match(query);
      }
      
      if (query) {
        const queryRe = new RegExp(query.replace(/\s+/g, '.+'), 'i');
        list = list.filter(
          (item) =>
            match(item.email, queryRe) ||
            match(item.firstName, queryRe) ||
            match(item.lastName, queryRe) ||
            match(item.companyId, queryRe) ||
            match(item.companyName, queryRe)
        );
      }
      setLicenses(list);
    } catch (e) {
      setError(e);
    }
  }, [query, setError, setLicenses]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      <Managed state={state}>
        <>
          <h1>PCS Licenses</h1>
          <form type='get'>
          <InputGroup
              name="filter"
              leftIcon="filter"
              defaultValue={params.get("filter") || ''}
              placeholder="Please enter query and press enter"
            />
          </form>
          <StaticTable fields={PCS_LICENSE_FIELDS} items={state.data || []} />
        </>
      </Managed>
    </>
  );
}
